/**
 * Fonte única da verdade das CSS vars de cor da loja.
 *
 * Usado por:
 *   - `vuex/actions.js` → ação `setSiteConfig` (boot da loja)
 *   - `utils/tema-preview-listener.js` → preview ao vivo do admin
 *
 * Regras de fallback ficam aqui, então qualquer mudança se propaga
 * automaticamente para ambos os consumidores sem duplicação.
 *
 * Não executa se `app_color_brand_primary` estiver vazio (espelha a
 * guarda original do `setSiteConfig`).
 */

function colorVal(specific, fallback, def = "#fff") {
  return (
    (typeof specific === "string" && specific.trim()) ||
    (typeof fallback === "string" && fallback.trim()) ||
    def
  );
}

export function contrastColor(hex) {
  if (typeof hex !== "string") return "#fff";

  const c = hex.trim().replace(/^#/, "");
  const full = c.length === 3 ? c.replace(/(.)/g, "$1$1") : c;
  if (full.length !== 6) return "#fff";

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? "#000" : "#fff";
}

function setVar(name, value) {
  if (value) {
    document.documentElement.style.setProperty(name, value);
  } else {
    document.documentElement.style.removeProperty(name);
  }
}

export function applyColorVars(payload) {
  if (!payload || !payload.app_color_brand_primary) return;

  const primary = payload.app_color_brand_primary;
  const primaryContrast = payload.app_color_brand_primary_contrast;
  const secondary = payload.app_color_brand_secondary;

  setVar("--brand-primary", primary);
  setVar("--brand-secondary", primary);

  setVar(
    "--header-primary",
    colorVal(payload.app_color_header_primary, primary, "#2a6a4b")
  );

  if (payload.app_color_header_contrast) {
    setVar("--header-contrast", payload.app_color_header_contrast);
  } else {
    setVar("--header-contrast", "");
  }

  setVar(
    "--header-category-primary",
    colorVal(payload.app_color_header_category_primary, primary, "#2a6a4b")
  );
  setVar(
    "--header-category-contrast",
    colorVal(payload.app_color_header_category_contrast, primaryContrast)
  );
  setVar(
    "--button-primary",
    colorVal(payload.app_color_button_primary, primary, "#2a6a4b")
  );
  setVar(
    "--button-contrast",
    colorVal(payload.app_color_button_contrast, primaryContrast)
  );
  setVar("--brand-primary-contrast", primaryContrast || "#fff");

  if (secondary) {
    setVar("--brand-accent", secondary);
    setVar(
      "--brand-accent-contrast",
      colorVal(payload.app_color_brand_secondary_contrast, primary)
    );
  } else {
    setVar("--brand-accent", "");
    setVar("--brand-accent-contrast", "");
  }
}

export default applyColorVars;
